import React from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import strings from '../../../localization';

import styles from './styles';

const PublicShiftHeader = () =>
  (
    <Box sx={styles.headerContainer}>
      <Typography sx={styles.title}>{strings.publicShiftsHeader}</Typography>
      <Typography sx={styles.caption}>{strings.toSeeMoreAvailable}</Typography>
    </Box>
  );

export default PublicShiftHeader;
